import { isBoolean, isEmpty, isNumber } from "lodash";

export function throwIfEmpty<T>(item: T, name: string): asserts item is Exclude<T, undefined | null> {
  if (!isNumber(item) && !isBoolean(item) && isEmpty(item)) {
    throw new Error(`${name} is null or undefined or empty`);
  }
}
